import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import AIButton from './Button';
import PagePanel from '../../page/Panel';
import Frame from './Frame';
var appId = 'com.ecrion.ai';
var panelVisibleStorageKey = "ECR.".concat(appId, ".PanelVisible");
/**
 * @param {import('./types').AIProps} props
 */

var AI = function AI(_ref) {
  var defaultOpen = _ref.defaultOpen,
      rest = _objectWithoutProperties(_ref, ["defaultOpen"]);

  var _React$useState = React.useState(defaultOpen),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpenFlag = _React$useState2[1];

  var setOpen = function setOpen(flag) {
    localStorage.setItem(panelVisibleStorageKey, flag);
    setOpenFlag(flag);
  };

  React.useEffect(function () {
    var panelVisible = localStorage.getItem(panelVisibleStorageKey);
    if (panelVisible === 'true') setOpenFlag(true);
  }, []);
  if (!open) return React.createElement(AIButton, {
    onClick: function onClick() {
      return setOpen(true);
    }
  });
  return React.createElement(PagePanel, {
    id: "".concat(appId, ".sidebar")
  }, React.createElement(Frame, Object.assign({}, rest, {
    onClose: function onClose() {
      return setOpen(false);
    }
  })));
};

AI.defaultProps = {
  defaultOpen: false
};
export default AI;